import React, { useState, useEffect } from 'react';
import ComicTitle from './ui/ComicTitle';
import GroupDrawing from '../assets/groupDrawing.png';

export default function ComicScrollText() {
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const maxScroll = 1500;
    const progress = Math.min(scrollY / maxScroll, 1);
    const translateX = (1 - progress) * 30;

    return (
        <div className="relative isolate overflow-hidden bg-muted/30 halftone-bg min-h-[70vh] pt-8">
            <div className="sticky top-6 flex flex-col items-center px-4">
                <div
                    className="relative mb-6 transition-transform duration-300 ease-out"
                    style={{ transform: `translateX(-${translateX}%)` }}
                >
                    <div className="relative inline-block">
                        <ComicTitle text="See it. Name it." />
                    </div>

                    <div className="absolute -top-8 -right-8 flex h-16 w-16 rotate-12 items-center justify-center rounded-full bg-red-500">
                        <span className="text-2xl font-black text-yellow-300">★</span>
                    </div>
                </div>

                <div
                    className="relative transition-transform duration-300 ease-out"
                    style={{ transform: `translateX(${translateX}%)` }}
                >
                    <div className="relative inline-block">
                        <ComicTitle
                            text="Flip The Script!"
                            shadowColor="#0066FF"
                            highlightColor="#67e8f9"
                        />
                    </div>

                    <div className="absolute -bottom-8 -left-8 flex h-20 w-20 -rotate-12 items-center justify-center border-4 border-black bg-yellow-300">
                        <span className="text-3xl font-black text-black">Hey!</span>
                    </div>
                </div>

                <div className="relative mt-12 max-w-3xl">
                    <div className="relative rounded-3xl border-4 border-black bg-white p-6 shadow-lg">
                        <p className="text-center text-lg font-bold leading-relaxed text-black md:text-xl">
                            A bold, comic-style dialogue game designed for middle and high school
                            students to tackle bullying through real conversation, empathy-building,
                            and actionable peer support.
                        </p>

                        <div className="absolute -top-8 left-1/2 -translate-x-1/2 transform">
                            <div className="relative">
                                <div className="h-12 w-12 rounded-t-full border-4 border-b-0 border-black bg-white"></div>
                                <div className="absolute top-6 left-1/2 h-8 w-8 -translate-x-1/2 transform rounded-tl-full border-4 border-b-0 border-r-0 border-black bg-white"></div>
                                <div className="absolute top-10 left-1/2 h-4 w-4 -translate-x-1/2 transform rounded-tl-full border-4 border-b-0 border-r-0 border-black bg-white"></div>
                            </div>
                        </div>

                        <div className="absolute -right-3 -top-3 flex h-8 w-8 items-center justify-center rounded-full border-2 border-black bg-cyan-300">
                            <span className="text-xs font-black text-black">!</span>
                        </div>
                    </div>
                </div>

                <div className="pointer-events-none absolute inset-0 overflow-hidden">
                    {[...Array(6)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute h-1 -rotate-12 transform bg-black"
                            style={{
                                width: `${20 + i * 10}%`,
                                top: `${20 + i * 10}%`,
                                left: `-${10 + i * 5}%`,
                                opacity: 0.1 + progress * 0.2,
                            }}
                        />
                    ))}
                </div>
            </div>

            <div className="pt-[320px]">
                <img
                    src={GroupDrawing}
                    alt="Group Drawing"
                    className="pointer-events-none absolute bottom-0 left-1/2 h-auto max-h-[700px] w-auto max-w-[750px] -translate-x-1/2 transform"
                />
            </div>
        </div>
    );
}